// extracted by mini-css-extract-plugin
export default {"imageInformation":"RetouchCaseDetail_imageInformation__4ueWg","zeroMargin":"RetouchCaseDetail_zeroMargin__3PtTC","imageActionWrapper":"RetouchCaseDetail_imageActionWrapper__U+lHX"};